import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';

import * as style from './ScrollButtons.css';

export interface IScrollButtonsProps {
  floating?: boolean;
  onScroll: (direction: 'left' | 'right') => void;
}

export const ScrollButtons = ({ floating, onScroll }: IScrollButtonsProps): React.JSX.Element => {
  const handleScrollLeft = React.useCallback(() => onScroll('left'), [onScroll]);
  const handleScrollRight = React.useCallback(() => onScroll('right'), [onScroll]);

  const size = floating ? 'XS' : 'M';

  return (
    <div className={clsx(style['container'], floating && style['container--floating'])}>
      <Button
        beforeIcon={<IconActionChevronLeft16 color="current_color" />}
        onClick={handleScrollLeft}
        size={size}
        theme="main_secondary"
        title="Прокрутить влево"
      />
      <Button
        beforeIcon={<IconActionChevronRight16 color="current_color" />}
        onClick={handleScrollRight}
        size={size}
        theme="main_secondary"
        title="Прокрутить вправо"
      />
    </div>
  );
};
